import { Tooltip } from "react-tooltip";
import classes from "./custom_tooltip.module.css";

export default function CustomTooltip({id, children, place_type, theme="light", ...props}) {
    props.className = `${props.className} ${classes.tooltip} text-xs-semibold ${classes[theme]} ${classes[place_type]}`
    return <Tooltip id={id} {...props} classNameArrow={`${classes.arrow} ${classes[place_type]}`} place={place_type}>
        {children}
    </Tooltip>
}